import BinauralBrain from "@/components/BinauralBrain";

export default function BrainPage() {
  return (
    <div className="w-full">
      <div className="mx-auto max-w-6xl px-3 sm:px-6 py-4">
        <BinauralBrain />
      </div>
    </div>
  );
}
